import { render } from "./OrderCreated.vue?vue&type=template&id=19c5863d"
import script from "./OrderCreated.vue?vue&type=script&lang=js"
export * from "./OrderCreated.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__